export default __webpack_public_path__ + "static/media/tavi_medium.38f03080.jpg";